import { throwError as observableThrowError, Observable } from 'rxjs';

import { catchError } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';


import { ServiceBase } from '@app/services/base.service';
import { Meta } from '@app/models/meta.model';

@Injectable()
export class MetaService extends ServiceBase {
  constructor(private http: HttpClient) {
    super();
  }

  gravar(meta: Meta): Observable<any> {
    return this.http
      .post<any>(this.URL_API + 'configuracoes/meta',meta).pipe(
        catchError((error: any) => observableThrowError(error)));
  }

  deletar(ano: number, unidadeId: number): Observable<any> {
    return this.http
      .delete<any>(this.URL_API + `configuracoes/meta/${ano}/${unidadeId}`).pipe(
        catchError((error: any) => observableThrowError(error)));
  }

  obterPorChaveComposta(ano: number, unidadeId: number): Observable<any> {
    return this.http
      .get<any>(this.URL_API + `configuracoes/meta/${ano}/${unidadeId}`, { headers: { meta: ['search'] }}).pipe(
        catchError((error: any) => observableThrowError(error)));
  }

  obterLista(ano: string, pagina: number): Observable<any> {
    return this.http
      .get<any>(this.URL_API + `configuracoes/meta/lista/${ano}/${pagina}`, { headers: { meta: ['search'] }});
  }

  obterTodos() {
    return this.http.get<any>(this.URL_API + `configuracoes/meta`, { headers: { meta: ['search'] }});
  }
}
